import * as React from 'react';
import { BoxText } from './TextInBox.styles';

interface TextInBoxProps {}

export const TextInBox: React.SFC<TextInBoxProps> = ({ children }) => (
  <BoxText>{children}</BoxText>
);
